import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { renderCollection } from "@saleor/misc";
import React, { useRef } from "react";

// import { useIntl } from "react-intl";
import useStyles from "./styles";

interface TableUploadFail {
  tableData: any[];
}

const TableUploadFail: React.FC<TableUploadFail> = ({ tableData }) => {
  // const intl = useIntl();
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div className={classes.root} ref={containerRef}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">Line</MyTypography>
              </TableCellHeader>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">Sold-to</MyTypography>
              </TableCellHeader>

              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">Sale Org</MyTypography>
              </TableCellHeader>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">
                  Distribution Channel
                </MyTypography>
              </TableCellHeader>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">
                  Cust Material Code
                </MyTypography>
              </TableCellHeader>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">
                  SAP Material Code
                </MyTypography>
              </TableCellHeader>
              <TableCellHeader textAlign="left">
                <MyTypography variant="subtitle3">Remarks</MyTypography>
              </TableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {renderCollection(tableData, (item, index) => (
              <TableRow key={index}>
                <TableCell align="left" className={classes.colLine}>
                  <MyTypography variant="body3">
                    {item?.field ? item?.field : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left">
                  <MyTypography variant="body3">
                    {item?.data?.soldToCode ? item?.data?.soldToCode : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left">
                  <MyTypography variant="body3">
                    {item?.data?.salesOrganizationCode
                      ? item?.data?.salesOrganizationCode
                      : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left">
                  <MyTypography variant="body3">
                    {item?.data?.distributionChannelCode
                      ? item?.data?.distributionChannelCode
                      : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left">
                  <MyTypography variant="body3">
                    {item?.data?.soldToMaterialCode
                      ? item?.data?.soldToMaterialCode
                      : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left">
                  <MyTypography variant="body3">
                    {item?.data?.materialCode ? item?.data?.materialCode : "-"}
                  </MyTypography>
                </TableCell>

                <TableCell align="left" className={classes.colRemarks}>
                  <MyTypography variant="body3">
                    {item?.message ? item?.message : "-"}
                  </MyTypography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <StickyHorizontalScrollBar container={containerRef} bottom={160} />
      </div>
    </>
  );
};
export default TableUploadFail;
